/* eslint-disable camelcase */
export class GenericError extends Error {
  constructor(public error: string, public error_description: string) {
    super(error_description)
    Object.setPrototypeOf(this, GenericError.prototype)
  }

  static fromPayload({
    error,
    error_description,
  }: {
    error: string
    error_description: string
  }) {
    return new GenericError(error, error_description)
  }
}

export class TimeoutError extends GenericError {
  constructor() {
    super('timeout', 'Timeout')
    // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, TimeoutError.prototype)
  }
}

/**
 * Error thrown when the login popup times out (if the user does not complete auth)
 */
export class PopupTimeoutError extends TimeoutError {
  constructor(public popup: Window) {
    super()
    // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, PopupTimeoutError.prototype)
  }
}

export class PopupCancelledError extends GenericError {
  constructor(public popup: Window) {
    super('cancelled', 'Popup closed')
    // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, PopupCancelledError.prototype)
  }
}

export class PopupNotSupportedError extends GenericError {
  constructor(public popup: Window) {
    super('NotSupported', 'Popup is not supported in current environment')
    // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, PopupCancelledError.prototype)
  }
}
